import React from "react";
import { Send, Youtube, Instagram, Facebook } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => {
    return (
        <footer
            id="footer"
            data-testid="footer-section"
            className="relative overflow-hidden grain"
        >
            {/* Sunset cinematic backdrop */}
            <div
                className="absolute inset-0"
                style={{
                    background:
                        "radial-gradient(800px 400px at 50% 0%, rgba(212,175,55,0.18), transparent 60%), linear-gradient(180deg, #0C0A09 0%, #14100D 40%, #1A130C 70%, #0A0807 100%)",
                }}
            />
            <div className="halo bg-bronze/30 w-[520px] h-[400px] -bottom-20 left-1/2 -translate-x-1/2" />

            <div className="relative max-w-5xl mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-12">
                <div className="text-center">
                    <span className="text-[11px] font-mono-tracked text-champagne/80">
                        Citation
                    </span>
                    <blockquote className="mt-6 font-display italic text-3xl md:text-5xl text-ivory leading-[1.15] max-w-3xl mx-auto">
                        “Le vivant en toi sait{" "}
                        <span className="text-champagne-grad not-italic">le chemin.</span>”
                    </blockquote>
                    <div className="mt-8 flex items-center justify-center gap-4">
                        <span className="h-px w-10 bg-champagne/50" />
                        <span className="font-display italic text-champagne text-lg">
                            Gilles Delieuze
                        </span>
                        <span className="h-px w-10 bg-champagne/50" />
                    </div>
                </div>

                {/* Socials */}
                <div
                    className="mt-16 flex items-center justify-center gap-3 flex-wrap"
                    data-testid="footer-socials"
                >
                    {[
                        {
                            href: "https://t.me/+zLObzvUAXjVlYmY0",
                            label: "Telegram",
                            icon: Send,
                            testid: "social-telegram",
                        },
                        {
                            href: "https://www.youtube.com/@gillesdelieuze",
                            label: "YouTube",
                            icon: Youtube,
                            testid: "social-youtube",
                        },
                        {
                            href: "https://www.instagram.com/gillesdelieuze/",
                            label: "Instagram",
                            icon: Instagram,
                            testid: "social-instagram",
                        },
                        {
                            href: "https://www.facebook.com/gillesdelieuze",
                            label: "Facebook",
                            icon: Facebook,
                            testid: "social-facebook",
                        },
                    ].map(({ href, label, icon: Icon, testid }) => (
                        <a
                            key={label}
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group flex items-center gap-2.5 px-4 py-2.5 rounded-full glass-soft hover:border-champagne/50 transition-all duration-500"
                            data-testid={testid}
                            aria-label={label}
                        >
                            <Icon className="w-4 h-4 text-champagne group-hover:scale-110 transition-transform" />
                            <span className="text-xs font-mono-tracked text-ivory/70 group-hover:text-ivory">
                                {label}
                            </span>
                        </a>
                    ))}
                </div>

                <div className="mt-20 pt-8 border-t border-champagne/15 flex flex-col md:flex-row items-center justify-between gap-6">
                    <Logo size="sm" />
                    <p className="text-[11px] font-mono-tracked text-ivory/45">
                        © {new Date().getFullYear()} · Portail Gilles Delieuze
                    </p>
                    <a
                        href="https://gillesdelieuze.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-site-link"
                        className="text-[11px] font-mono-tracked text-champagne/70 hover:text-champagne transition-colors"
                    >
                        gillesdelieuze.com →
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
